import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef } from "react";
import { clsx } from "clsx";
/* empty css          */
import { markdown } from "../../utility/markdown.js";
const MarkdownContent = forwardRef((t0, ref) => {
  const $ = c(15);
  let children;
  let t1;
  let t2;
  let t3;
  if ($[0] !== ref || $[1] !== t0) {
    const {
      children: t42,
      onlyShowFirstChild,
      type,
      ...props
    } = t0;
    children = t42;
    t1 = props;
    t2 = ref;
    t3 = clsx(`graphiql-markdown-${type}`, onlyShowFirstChild && "graphiql-markdown-preview", props.className);
    $[0] = ref;
    $[1] = t0;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    children = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children) {
    t4 = markdown.render(children);
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      __html: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t5) {
    t6 = /* @__PURE__ */ jsx("div", { ...t1, ref: t2, className: t3, dangerouslySetInnerHTML: t5 });
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
});
MarkdownContent.displayName = "MarkdownContent";
export {
  MarkdownContent
};
//# sourceMappingURL=index.js.map
